import React from 'react';
import CommonPage from '../../components/CommonPage';
const pageType = "WEB";

function WebAdmin(props) {
    return <CommonPage pageType={pageType} />;
}

export default WebAdmin;